import { MaintenanceScopeOptions, maintenanceScopeOptionsMessages } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import type { RadioOption } from "src/components/form/radio/radioGroup/RadioGroup"

export const useLatestMaintenanceScopeOptions = (): RadioOption[] => {
	const { formatMessage } = useIntl()
	return [
		{
			label: formatMessage(maintenanceScopeOptionsMessages.NO_SELECTION),
			value: MaintenanceScopeOptions.NO_SELECTION,
		},
		{
			label: formatMessage(maintenanceScopeOptionsMessages.MINOR_SERVICE),
			value: MaintenanceScopeOptions.MINOR_SERVICE,
		},
		{
			label: formatMessage(maintenanceScopeOptionsMessages.MAJOR_SERVICE),
			value: MaintenanceScopeOptions.MAJOR_SERVICE,
		},
	]
}
